import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DropdownModal from '../common/modals/DropdownModal';
import DropdownArrowIcon from '../searchResults/rapidSearchFiltersV2/cruxFilterDropdown/components/DropdownArrowIcon';

export default class DropdownSelect extends Component {
    static propTypes = {
        overrideDropdown: PropTypes.bool,
        dropdownChildClass: PropTypes.any,
        classNameForEvent: PropTypes.string,
        customClassName: PropTypes.string,
        placeholder: PropTypes.string,
        customIcon: PropTypes.element,
        value: PropTypes.any,
        isOpen: PropTypes.bool,
        onFocus: PropTypes.func,
    };

    state = {
        isOptionsVisible: false,
    };

    componentDidUpdate(prevProps) {
        if (this.props.isOpen !== undefined && this.props.isOpen !== prevProps.isOpen) {
            this.setState({ isOptionsVisible: this.props.isOpen });
        }
    }

    handleClick = () => {
        if (this.isControlled()) {
            if (this.props.onFocus) {
                this.props.onFocus();
            }
        } else {
            this.setState(prevState => ({
                isOptionsVisible: !prevState.isOptionsVisible,
            }));
        }
    }

    handleClose = () => {
        if (this.isControlled()) {
            const currentIsOpen = this.getIsOpen();
            if (currentIsOpen && this.props.onFocus) {
                this.props.onFocus();
            }
        } else {
            this.setState({ isOptionsVisible: false });
        }
    }

    isControlled = () => {
        return this.props.isOpen !== undefined && this.props.onFocus !== undefined;
    }

    getIsOpen = () => {
        return this.isControlled() ? this.props.isOpen : this.state.isOptionsVisible;
    }

    render() {
        const dropdownChildClass = this.props.dropdownChildClass ? this.props.dropdownChildClass : '';
        const customClassName = this.props.customClassName ? ` ${this.props.customClassName}` : '';
        const isOpen = this.getIsOpen();
        return (
            <div
                ref={node => this.node = node}
                className={
                    `dropdown-select${isOpen ? ' open' : ''}${customClassName}`
                }
            >
                <div className="dropdown-heading" onClick={this.handleClick}>
                    <span id="dropdownSelectedValue" className="dropdown-heading-value">
                        { !this.props.value && this.props.placeholder
                            ? <span className="placeholder">{ this.props.placeholder }</span>
                            : this.props.value }
                    </span>
                    {
                        this.props.customIcon
                            ? <span className="custom-icon">{this.props.customIcon}</span>
                            : <DropdownArrowIcon sx={{ marginRight: '-6px !important' }} isOpen={isOpen} />
                    }
                </div>
                {isOpen &&
                    <DropdownModal
                        classNameForEvent={this.props.classNameForEvent}
                        customClass={`dropdown-options ${dropdownChildClass}`}
                        isVisible={isOpen}
                        onModalClose={this.handleClose}
                        overrideDropdown={this.props.overrideDropdown}
                        >
                        {
                            this.props.children
                        }
                    </DropdownModal>
                }
            </div>
        );
    }
}
